import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source, Marker } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import MarkerLayer from './MarkerLayer'
import diff from '../utility/diff'
import { LAND_DEFORMATION_INSAR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'

const id = 'LandDeformationInsar'
const authId = 'LandDeformation'
const markerId = 'LandDeformationCalifornia'

class LandDeformationInsar extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentDidMount () {
    const { map } = this.context
    map.on('click', id, this.handleClick)
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('click', id, this.handleClick)
    map.off('mousemove', id, this.handleMouseMove)
  }

  handleClick = event => {
    console.log('click')
    const { map } = this.context
    const { layerRendered } = this.props
    console.log(this.props)
    if (!layerRendered) {
      return null
    }    
    console.log(event)
    return null
  }

  handleMouseMove = event => {
    console.log('mousemove')
    return null
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, markerLngLat } = this.props
    const { map } = this.context
    
    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [LAND_DEFORMATION_INSAR({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
      <Source key={`${id}Source`} id={id} tileJsonSource={rasterSource} />,
      <Layer key={id} type='raster' id={id} sourceId={id} paint={paint} />
        <MarkerLayer id={markerId} />
      </div>
      )
        
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id),
      time: state.layer.times.LandDeformationInsar || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(LandDeformationInsar)



// WEBPACK FOOTER //
// ./src/layers/LandDeformationInsar.js